export default "__VITE_ASSET__8d165642__"